import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d99bafb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.31_css-loader@6.11.0_webpack@5.93.0__lodash@4.17.21__2224vjmmlkuugiasgw4yfadix4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99bafb",
  null
  
)

export default component.exports